<button class="export-button" [class.large]="large" (click)="_export($event)" [disabled]="disabled">
    <div class="icon"></div>
    <div class="title"><tra slug="sa_sa_actions_export"></tra></div>
</button>